// FAQ page configuration — data constants only, no component logic.
// (TP_FAQ_BRIEF §4: everything is data — no question text, image path or
// marker coordinate lives in component code.)
// The contact CTA opens the platform's existing ContactSupportModal
// (FaqContactCard, LEAD_NOTES T2 №8) — no mailto constant anymore.

// Image name contract (TP_FAQ_BRIEF §5, served auth-protected by Ticket 3):
//   faq/<tier>/<category>/<question-key>.<desktop|mobile>.png
export const faqImagePath = (tier, category, questionKey, set) =>
  `faq/${tier}/${category}/${questionKey}.${set}.png`;

// Media set geometry (design sheet F8-B/E + notes).
export const FAQ_MEDIA_SETS = {
  desktop: { ratio: "16 / 10", sizeNote: "1600 × 1000 · 16:10 · swapped by file name" },
  mobile: { ratio: "9 / 16", sizeNote: "900 × 1600 · 9:16 · swapped by file name" },
};

// Placeholder-system key display (design prop `showKeys`). T1 ran on
// placeholder data with visible mono keys proving the data model; with the
// real content wired (Ticket 2) the keys are off. Flip on locally to inspect
// anchors/slot keys.
export const FAQ_SHOW_KEYS = false;

// Subgroup headers appear inside a category from this many visible questions
// upward (design note 5: "~5 questions upward"; smaller categories stay flat).
export const FAQ_SUBGROUP_THRESHOLD = 5;
